import * as React from 'react';
import { ISuggestionItem } from '../../types';
import { SUGGEST_ITEM_FLEX_GAP_SIZE } from '../constants';

export function useIconMargin(suggestions: ISuggestionItem<unknown>[]) {
  // В этот список попадают только элементы иконок из итемов с { type: 'title' }.
  // Только они нужны для расчета отступа.
  const titleItemsIconElements = React.useRef<(HTMLDivElement | undefined)[]>([]);
  const [iconMargin, setIconMargin] = React.useState<number>(0);

  React.useEffect(() => {
    titleItemsIconElements.current = [...Array(suggestions.length)].map((_el, i) => titleItemsIconElements.current[i]);
    setIconMargin(Math.max(0, ...titleItemsIconElements.current.map(el => el?.clientWidth ?? 0)));
  }, [suggestions]);

  const setTitleItemRefByIndex = React.useCallback(
    (listIndex: number) => (iconElement: HTMLDivElement) => {
      if (suggestions[listIndex].type === 'title') {
        titleItemsIconElements.current[listIndex] = iconElement;
      }
    },
    [suggestions],
  );

  const getIconMarginForItem = React.useCallback(
    (suggestion: ISuggestionItem<unknown>) => {
      if (suggestion.leftIcon || !iconMargin) {
        return 0;
      }

      return iconMargin + SUGGEST_ITEM_FLEX_GAP_SIZE;
    },
    [iconMargin],
  );

  return { getIconMarginForItem, setTitleItemRefByIndex };
}
